import { render, staticRenderFns } from "./LeGenerateGameImage.vue?vue&type=template&id=47a53452"
import script from "./LeGenerateGameImage.vue?vue&type=script&lang=js"
export * from "./LeGenerateGameImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports